// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-multi-select {
  position: relative;
  display: block;
  width: 100%;
}
.custom-multi-select.disabled .custom-multi-select-toggle {
  background-color: #e9ecef;
  cursor: not-allowed;
}

.custom-multi-select-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  min-height: 38px;
  padding: 6px 12px;
}
.custom-multi-select-toggle:hover:not(.disabled) {
  border-color: #80bdff;
}
.custom-multi-select-toggle.open {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.selected-content {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.placeholder-text {
  color: #6c757d;
}
.placeholder-text.has-value {
  color: #495057;
  display: none;
}

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.selected-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  font-size: 12px;
}
.selected-tag .close {
  background: none;
  border: none;
  color: inherit;
  font-size: 14px;
  line-height: 1;
  padding: 0;
  margin-left: 4px;
  cursor: pointer;
  opacity: 0.7;
}
.selected-tag .close:hover {
  opacity: 1;
}

.dropdown-arrow {
  margin-left: 8px;
  color: #6c757d;
  transition: transform 0.2s ease;
}
.dropdown-arrow .fa-flip-vertical {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
}
.dropdown-menu.show {
  display: block;
}

.search-container {
  padding: 8px;
  border-bottom: 1px solid #e9ecef;
}

.search-input {
  border: 1px solid #ced4da;
}
.search-input:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.dropdown-items {
  max-height: 150px;
  overflow-y: auto;
}

.custom-option {
  cursor: pointer;
}
.custom-option:hover {
  background-color: #f8f9fa;
}
.custom-option.selected {
  background-color: #e7f3ff;
}

.form-check {
  margin: 0;
  padding-left: 1.25rem;
}
.form-check .form-check-input {
  margin-left: -1.25rem;
}
.form-check .form-check-label {
  margin-bottom: 0;
  cursor: pointer;
}

.clear-all {
  cursor: pointer;
  color: #6c757d;
}
.clear-all:hover {
  background-color: #f8f9fa;
  color: #495057;
}

.dropdown-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/custom-multi-select/custom-multi-select.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;AACF;AAEI;EACE,yBAAA;EACA,mBAAA;AAAN;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAFF;AAIE;EACE,qBAAA;AAFJ;AAKE;EACE,qBAAA;EACA,gDAAA;AAHJ;;AAOA;EACE,OAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;AAJF;AAME;EACE,cAAA;EACA,aAAA;AAJJ;;AAQA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AALF;AAOE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AALJ;AAOI;EACE,UAAA;AALN;;AAUA;EACE,gBAAA;EACA,cAAA;EACA,+BAAA;AAPF;AASE;EACE,yBAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,8CAAA;AARF;AAUE;EACE,cAAA;AARJ;;AAYA;EACE,YAAA;EACA,gCAAA;AATF;;AAYA;EACE,yBAAA;AATF;AAWE;EACE,qBAAA;EACA,gDAAA;AATJ;;AAaA;EACE,iBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,eAAA;AAVF;AAYE;EACE,yBAAA;AAVJ;AAaE;EACE,yBAAA;AAXJ;;AAeA;EACE,SAAA;EACA,qBAAA;AAZF;AAcE;EACE,qBAAA;AAZJ;AAeE;EACE,gBAAA;EACA,eAAA;AAbJ;;AAiBA;EACE,eAAA;EACA,cAAA;AAdF;AAgBE;EACE,yBAAA;EACA,cAAA;AAdJ;;AAkBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAfF","sourcesContent":[".custom-multi-select {\n  position: relative;\n  display: block;\n  width: 100%;\n  \n  &.disabled {\n    .custom-multi-select-toggle {\n      background-color: #e9ecef;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.custom-multi-select-toggle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  min-height: 38px;\n  padding: 6px 12px;\n  \n  &:hover:not(.disabled) {\n    border-color: #80bdff;\n  }\n  \n  &.open {\n    border-color: #80bdff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  }\n}\n\n.selected-content {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n}\n\n.placeholder-text {\n  color: #6c757d;\n  \n  &.has-value {\n    color: #495057;\n    display: none;\n  }\n}\n\n.selected-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.selected-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 6px;\n  font-size: 12px;\n  \n  .close {\n    background: none;\n    border: none;\n    color: inherit;\n    font-size: 14px;\n    line-height: 1;\n    padding: 0;\n    margin-left: 4px;\n    cursor: pointer;\n    opacity: 0.7;\n    \n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.dropdown-arrow {\n  margin-left: 8px;\n  color: #6c757d;\n  transition: transform 0.2s ease;\n  \n  .fa-flip-vertical {\n    transform: rotate(180deg);\n  }\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  background-color: #fff;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n  \n  &.show {\n    display: block;\n  }\n}\n\n.search-container {\n  padding: 8px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.search-input {\n  border: 1px solid #ced4da;\n  \n  &:focus {\n    border-color: #80bdff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  }\n}\n\n.dropdown-items {\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.custom-option {\n  cursor: pointer;\n  \n  &:hover {\n    background-color: #f8f9fa;\n  }\n  \n  &.selected {\n    background-color: #e7f3ff;\n  }\n}\n\n.form-check {\n  margin: 0;\n  padding-left: 1.25rem;\n  \n  .form-check-input {\n    margin-left: -1.25rem;\n  }\n  \n  .form-check-label {\n    margin-bottom: 0;\n    cursor: pointer;\n  }\n}\n\n.clear-all {\n  cursor: pointer;\n  color: #6c757d;\n  \n  &:hover {\n    background-color: #f8f9fa;\n    color: #495057;\n  }\n}\n\n.dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
